import {Injectable} from '@angular/core';
import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';
import {StatusEventSignalColumnKind} from '@constants/machine/status-event-signal/status-event-signal-column-type.enum';
import {
  COLUMNS_SEPARATOR,
  STATUS_EVENT_SIGNAL_LANGUAGE_COLUMN_PREFIX
} from '@constants/machine/status-event-signal/status-event-signal.constants';
import {TranslateService} from '@ngx-translate/core';
import {StatusEventSignalParsingException} from '@models/machine/status-event-signal/status-event-signal-parsing-exception';
import {
  StatusEventExceptionTypes
} from '@constants/machine/status-event-signal/status-event-exception-types.enum';

@Injectable({
  providedIn: 'root'
})
export class StatusEventSignalCsvExportService {

  constructor(private translate: TranslateService) {
  }


  public parseStatusEventDetailsToCsv(details: Map<string, StatusEventDetails>): string {
    let message: string = '';
    if (!details || details.size === 0) {
      message = this.translate.instant('The source to export to CSV is invalid');
      throw new StatusEventSignalParsingException(StatusEventExceptionTypes.DOWNLOAD_INVALID_SOURCE, message);
    }

    const firstEntry: StatusEventDetails = Array.from(details.values())[0];

    const languageKeys = this.getSortedKeysArray(firstEntry.localizations);
    const metadataKeys = this.getSortedKeysArray(firstEntry.metadata);

    const headerRow = this.generateHeaderRow(metadataKeys, languageKeys);
    const content = this.generateContentBody(details, metadataKeys, languageKeys);

    return headerRow + '\n' + content;

  }

  private getSortedKeysArray(map: Map<string, string>): string[] {
    if (!map || map.size === 0) {
      return [];
    }

    const keys: string[] = Array.from(map.keys());
    return keys.sort();
  }

  private generateHeaderRow(metadataKeys: string[], languageKeys: string[]): string {
    const result: string[] = [];
    result.push(StatusEventSignalColumnKind.CODE);
    result.push(StatusEventSignalColumnKind.TYPE);
    result.push(StatusEventSignalColumnKind.DESCRIPTION);


    for (const metadata of metadataKeys) {
      result.push(metadata);
    }
    for (const language of languageKeys) {
      result.push(STATUS_EVENT_SIGNAL_LANGUAGE_COLUMN_PREFIX + language);
    }
    return result.join(COLUMNS_SEPARATOR);

  }

  private generateContentBody(details: Map<string, StatusEventDetails>, metadataKeys: string[], languageKeys: string[]): string {
    let result: string = '';

    details.forEach((item: StatusEventDetails) => {
      result += this.generateContentRow(item, metadataKeys, languageKeys) + '\n';
    });

    return result;
  }

  private generateContentRow(event: StatusEventDetails, metadataKeys: string[], languageKeys: string[]): string {
    const result: string[] = [];
    result.push(event.code);
    result.push(event.type);
    result.push(event.description);

    for (const metadata of metadataKeys) {
      let value = event.metadata.get(metadata);
      if (!value) {
        value = '';
      }
      result.push(value);
    }
    for (const language of languageKeys) {
      let value = event.localizations.get(language);
      if (!value) {
        value = '';
      }
      result.push(value);
    }

    return result.join(COLUMNS_SEPARATOR);
  }


}
